/******************************************************************************
 * Copyright (c) 2026 Contributors to the Eclipse Foundation.
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * https://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *****************************************************************************/

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { PageContainer } from 'openvsx-webui';
import { Link as RouteLink } from 'react-router';

// Server failures land here; missing pages are served at their own URL by upstream's NotFound.
const ErrorPage = () => (
  <PageContainer>
    <Typography variant='h4' component='h1' sx={{ mt: 4 }}>
      Something went wrong
    </Typography>
    <Typography sx={{ mt: 2 }}>The registry could not complete your request. Please try again in a moment.</Typography>
    <Button component={RouteLink} to='/' variant='contained' color='secondary' sx={{ mt: 3 }}>
      Back to the home page
    </Button>
  </PageContainer>
);

export default ErrorPage;
